<template>
	<modal
		:modal-id="userAndRoles.users.addModalId"
		:title="modalTitle"
		:preloader="preloader"
		:modal-scroll="false"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				ref="form"
				:data-url="
					hasData
						? `admin/auth/users/attach-roles/${userAndRoles.rowData.id}`
						: `/admin/auth/users/add-user`
				"
				:class="{ 'loading-opacity': preloader }"
			>
				<div class="form-group row align-items-center">
					<label for="user_name" class="col-sm-3 mb-0">
						{{ $t("first_name") }}
					</label>
					<app-input
						id="user_name"
						class="col-sm-9"
						type="text"
						v-model="user.first_name"
						:placeholder="$t('enter_first_name')"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="user_last_name" class="col-sm-3 mb-0">
						{{ $t("last_name") }}
					</label>
					<app-input
						id="user_last_name"
						class="col-sm-9"
						type="text"
						v-model="user.last_name"
						:placeholder="$t('enter_last_name')"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="!hasData">
					<label for="userEmail" class="col-sm-3 mb-0">
						{{ $t("email") }}
					</label>
					<app-input
						id="userEmail"
						class="col-sm-9"
						type="email"
						v-model="user.email"
						:placeholder="$t('enter_user_email')"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center" v-if="!hasData">
					<label for="userPassword" class="col-sm-3 mb-0">
						{{ $t("password") }}
					</label>
					<app-input
						id="userPassword"
						class="col-sm-9"
						type="password"
						v-model="user.password"
						:placeholder="$t('enter_user_password')"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center mb-0">
					<label for="roles" class="col-sm-3 mb-0">
						{{ $t("role") }}
					</label>
					<app-input
						id="roles"
						class="col-sm-9"
						type="multi-select"
						:list="roleLists"
						list-value-field="name"
						:isAnimatedDropdown="true"
						v-model="roles"
						:required="true"
					/>
				</div>
				
                <div class="form-group row align-items-center">
                    <label for="userExaminerStatus" class="col-sm-3 mb-0">
                        Examiner
                    </label>
                    <div class="col-sm-8">
                        <app-input id="userExaminerStatus" :list-value-field="''" type="single-checkbox" v-model="user.examiner_status" />
                    </div>
                </div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { UserAndRoleMixin } from "../Mixins/UserAndRoleMixin";
import * as actions from "../../../../Config/ApiUrl";

export default {
	name: "UserAddModal",
	mixins: [FormMixin, ModalMixin, UserAndRoleMixin],
	data() {
		return {
			user: {},
			roles: [],
			roleLists: [],
			hasData: false,
			modalTitle: this.$t("add_users"),
		};
	},
	created() {
		if (!_.isEmpty(this.userAndRoles.rowData)) {
			this.hasData = true;
			(this.modalTitle =
				this.$t("add_users") +
				" - " +
				this.userAndRoles.rowData.full_name),
				(this.user.email = this.userAndRoles.rowData.email),
				(this.user.first_name = this.userAndRoles.rowData.first_name),
				(this.user.last_name = this.userAndRoles.rowData.last_name),
				(this.user.password = this.userAndRoles.rowData.password),
				(this.user.examiner_status = this.userAndRoles.rowData.examiner_status),
				(this.roles = this.userAndRoles.rowData.roles.map(function (
					roles
				) {
					return roles.id;
				}));
		}
		this.getRoles();
	},
	methods: {
		submit() {
			this.user.roles = this.roles;
			this.save(this.user);
		},

		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.reLoadTable();
		},
		getRoles() {
			let url = actions.ROLES + "?per_page=1000";

			this.preloader = this.hasData ? true : false;

			this.axiosGet(url)
				.then((response) => {
					this.roleLists = response.data.data;
				})
				.catch(({ response }) => {})
				.finally(() => {
					this.preloader = false;
				});
		},
	},
};
</script>
